import { render, staticRenderFns } from "./CalendarDetail.html?vue&type=template&id=4505afd6&external"
import script from "./CalendarDetail.ts?vue&type=script&lang=ts&external"
export * from "./CalendarDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./CalendarDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports